module.exports = __webpack_public_path__ + "img/AWARENESS_2023_BRAND_BUSINESSBLOOMS_SML_2000x180.fb9617dc.gif";